import styled, { keyframes } from 'styled-components';
import { inkA } from '../tokens';

// Loading shimmer primitive shared by the v3 tables and report cards.
// Size/shape via transient props: $w (width), $h (height), $r (radius).

const pulse = keyframes`
  0% { opacity: 0.55; }
  50% { opacity: 1; }
  100% { opacity: 0.55; }
`;

const SkeletonBar = styled.div`
  flex-shrink: 0;
  height: ${(p) => p.$h || '14px'};
  width: ${(p) => p.$w || '70%'};
  border-radius: ${(p) => p.$r || '7px'};
  background: ${(p) => inkA(p.theme, 0.09)};
  animation: ${pulse} 1.2s ease-in-out infinite;
`;

export default SkeletonBar;
